module.exports = __webpack_public_path__ + "img/post_portem_poster.da17ddb3.jpg";